<nav class="nav nav-pills nav-justified">
  <a class="nav-item nav-link" [routerLink]="['message-mappings']" routerLinkActive="active">Message Mappings</a>
  <a class="nav-item nav-link" [routerLink]="['content-migration']" routerLinkActive="active">Content Migration</a>

</nav>

<div class="tabs-content">
  <router-outlet></router-outlet>
</div>
